import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CONTACTS_HELP_URL, DefaultLanguage } from '../../constants/Constants';
import { Localize } from './Localize';
import './ContactsNotEnabled.scss';

const ContactsNotEnabled = () => {
  const langId = useSelector((state) => state.language?.selectedlanguage?.id);
  const [localisedValues, setLocalisedValues] = useState(Localize[langId] || Localize[DefaultLanguage]);

  useEffect(() => {
    if (langId) {
      setLocalisedValues(Localize[langId] || Localize[DefaultLanguage]);
    }
  }, [langId]);

  return (
    <div className="contacts-not-enabled">
      <div className="contacts-not-enabled__card">
        <div className="contacts-not-enabled__icon">
          <span className="for-icon icon-address-book" aria-hidden="true" />
        </div>
        <h2 className="contacts-not-enabled__title">
          {localisedValues['feature_not_enabled_title']}
        </h2>
        <p className="contacts-not-enabled__desc">
          {localisedValues['feature_not_enabled_desc']}
        </p>
        <a
          className="contacts-not-enabled__learn-more"
          href={CONTACTS_HELP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {localisedValues['learn_more']}
        </a>
        <hr className="contacts-not-enabled__divider" />
        <h3 className="contacts-not-enabled__features-title">{localisedValues['features_title']}</h3>
        <div className="contacts-not-enabled__features">
          <div className="contacts-not-enabled__feature">
            <h4>{localisedValues['feature_shared_title']}</h4>
            <p>{localisedValues['feature_shared_desc']}</p>
          </div>
          <div className="contacts-not-enabled__feature">
            <h4>{localisedValues['feature_invites_title']}</h4>
            <p>{localisedValues['feature_invites_desc']}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactsNotEnabled;
